import { register } from './register';
import { translations, countries } from './translations';
import {
  BrandConfig,
  PayAndPlayProvider,
  PayAndPlayProviderConfiguration,
  PayAndPlayProviderConfigurationBuilder,
} from '@whitehatgaming/shared';
import { registerOntario } from './register.ontario';

const pnpProviders: PayAndPlayProviderConfiguration[] = [
  new PayAndPlayProviderConfigurationBuilder(PayAndPlayProvider.zimplerGo, 'FI').build(),
];

export const brandConfig: BrandConfig = {
  id: 152,
  loqateKey: 'WC78-EX93-PU33-XG17',
  licensee: 'whitezip',
  name: 'Ursacasino',
  displayName: 'Ursa Casino',
  path: 'ursacasino',
  register: register,
  registerOntario: registerOntario,
  translations: {
    translations: translations,
    countries: countries,
  },
  supportEmail: 'support@ursacasino.com',
  languages: ['en', 'de', 'fi', 'no', 'fr', 'es', 'pt'],
  payNPlayProviders: pnpProviders,
  payNPlaySkipCollectPersonalDetails: false,
  payNPlay: true,
  payNPlayCurrency: 'EUR',
  payNPlayForceManualAmount: false,
  googleAnalyticsCode: 'UA-70695623-5',
  payNPlayContactCapture: {
    email: false,
    phone: false,
  },
  logoUrl: 'assets/ursa-white.svg',
  customization: {
    playPageConfig: {
      logoDisplayed: true,
      pnpQuickDepositEnabled: true,
      showQuickDepositAmount: true,
      enableBackToHomeButtonOnPages: ['cancelled', 'registration_rejected'],
    },
  },
  ontario: {
    enabled: false,
  },
  routesRedirectedToLegacy: ['logout'],
  enableShowMarketingPreferencesOnHome: true,
};
